/*
郵便番号から住所を検索する
入力欄のグループ数、name属性がどのように設定されても対応できる冗長な形式

※以下の外部JSが必要
  <script src="//ajaxzip3.github.io/ajaxzip3.js" charset="UTF-8"></script>
※ライブラリがname属性準拠で動くため、全てのinputにユニークなnameが必須
*/

/*
最大構成例
<input type="text" name="zip1" class="js-zip-in--hogeZip">
<input type="text" name="zip2" class="js-zip-in--hogeZip">
<button type="button" class="js-zip" data-zip="hogeZip">
    住所検索
</button>
<input type="text" name="address1" class="js-zip-out--hogeZip">
<input type="text" name="address2" class="js-zip-out--hogeZip">
<input type="text" name="address3" class="js-zip-out--hogeZip">


最小構成例
<input type="text" name="zipFuga" class="js-zip-in--fugaZip">
<button type="button" class="js-zip" data-zip="fugaZip">
    住所検索2
</button>
<input type="text" name="addressFuga" class="js-zip-out--fugaZip">

*/

if (document.getElementsByClassName('js-zip')[0]) {
  module()
}
function module() {
  /* global AjaxZip3 */
  window.addEventListener('click', function (e) {
    const item = e.target.closest('.js-zip')
    if (!item) {
      return
    }

    const target = item.dataset.zip

    // 住所グループを取得する
    const inputList = document.querySelectorAll('.js-zip-in--' + target)
    const outputList = document.querySelectorAll('.js-zip-out--' + target)

    // 各入力欄のname属性を収集する
    const nameList = []
    for (const input of inputList) {
      nameList.push(input.name) // 配列の末尾に追加
    }
    if (!nameList[1]) {
      // 郵便番号欄が1つなら空データを入力
      nameList[1] = ''
    }
    for (const output of outputList) {
      nameList.push(output.name) // 配列の末尾に追加
    }
    if (!nameList[3]) {
      // 出力欄が不足していれば前の出力欄を指定
      nameList[3] = nameList[2]
    }
    if (!nameList[4]) {
      // 出力欄が不足していれば前の出力欄を指定
      nameList[4] = nameList[3]
    }

    // console.log({ nameList })

    /*
    各入出力先をnameから指定
    郵便番号上3桁もしくは7桁, 郵便番号下4桁（不要なら空欄）, 都道府県の出力先, 市区町村～町域の出力先
    */
    AjaxZip3.zip2addr(nameList[0], nameList[1], nameList[2], nameList[3])
  })
}
